import { createContext } from "react";
import type { User } from "../User";

/** @LearningJourney Authentication 14 - User data; only available inside SignedUpGuard */
export const signedUpContext = createContext<{ user: User } | undefined>(
  undefined
);
